import componentSwitch from 'utils/componentSwitch';

import { Combobox as DefaultCombobox } from './combobox';
import { Combobox as OverlayCombobox } from './overlayVariant/combobox';

export const Combobox = componentSwitch(DefaultCombobox, OverlayCombobox);
export type { ComboboxProps } from './combobox';
